import { Component, OnInit, Input } from '@angular/core';
import { InfoService } from '../../../core/services/tables-info/info.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { DataStatus } from 'src/app/models/Helpers/data-status';
import { Loader } from 'src/app/models/Helpers/loader';
import {VetrinaMese} from '../../../models/VetrinaMese';
import {VetrinaMeseService} from '../../../core/services/tables/vetrina-mese.service';
import {AddToWatchlistManagerService} from '../../../core/services/watchlists/add-to-watchlist-manager.service';

@Component({
  selector: 'app-vetrina-mese',
  templateUrl: './vetrina-mese.component.html',
  styleUrls: ['./vetrina-mese.component.scss']
})
export class VetrinaMeseComponent implements OnInit {
  @Input() data: VetrinaMese[];

  TABLE_TITLE = 'Vetrina Delle Opportunità - ';
  VIEW_ALL_PATH = '/menu/vetrina-mese';
  TABLE_SORT_HEADERS: Array<[string, string]> = [
    ['isin', 'Isin'],
    ['emittente', 'Emittente'],
    ['descrizione', 'Descrizione'],
    ['scadenza', 'Scadenza'],
    ['sottostanteBasket', 'Sottostante/Basket'],
    ['settore','Settore']
  ];
  tableInfoExists: boolean;

  newDate: Date;

  records: VetrinaMese[];
  dataStatus = new DataStatus();
  loader = new Loader();

  sortingFilter: string;

  constructor(
    private service: VetrinaMeseService,
    private infoService: InfoService,
    public dialogService: DialogService,
    private addToWatchlistManager: AddToWatchlistManagerService
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.records = this.data;
      this.dataStatus.setStatus('success');
    } else {
      this.getRecords();
    }

    this.tableInfoExists = this.infoService.isThereInfo(this.TABLE_TITLE);
    this.newDate = new Date(this.records[0].dataInserimento);
  }


  private async getRecords() {
    this.dataStatus.resetStatus();
    this.loader.show();

    const result = await this.service.getTop()
      .catch(error => {
        console.log('ERROR in VETRINA MESE SECTION - GET', error);
        this.dataStatus
          .setStatus('failure')
          .setAlertMessage('Errore nel caricamento dei dati')
          .setAlertClasses(['cedlab-danger']);
        this.loader.hide();
      });
    if (!result) { return; }

    if (result.length > 0) {
      this.records = result;
      this.dataStatus.setStatus('success');
    } else {
      this.records = [];
      this.dataStatus
        .setStatus('info')
        .setAlertMessage('Nessun isin presente')
        .setAlertClasses(['cedlab-info']);
    }
    this.loader.hide();
  }

  public triggerSorting({ active, direction }) {
    this.sortingFilter = active;

    if (direction === 'asc') {
      this.records.sort((a, b) =>
        a[this.sortingFilter] - b[this.sortingFilter] ? 1 : ((b[this.sortingFilter] > a[this.sortingFilter]) ? -1 : 0));
    } else if (direction === 'desc') {
      this.records.sort((a, b) =>
        b[this.sortingFilter] - a[this.sortingFilter] ? 1 : ((a[this.sortingFilter] > b[this.sortingFilter]) ? -1 : 0));
    } else {
      this.getRecords();
    }
  }


  public addIsinToWatchlist(isin: string) {
    this.addToWatchlistManager.addToWatchlist(isin);
  }

  public openInfoDialog() {
    const tableInfo = this.infoService.getTableInfo(this.TABLE_TITLE);
    this.dialogService.openTableInfoDialog(tableInfo);
  }
}
